export enum InputRestriction {
    Digits = 'DIGITS', // 0-9
    Integer = 'INTEGER',
    NoSpecialChars = 'NO_SPECIAL_CHARS'
}
